import { render } from "./registerPayMethod.vue?vue&type=template&id=4192093d&scoped=true"
import script from "./registerPayMethod.vue?vue&type=script&lang=js"
export * from "./registerPayMethod.vue?vue&type=script&lang=js"

import "./registerPayMethod.vue?vue&type=style&index=0&id=4192093d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4192093d"]])

export default __exports__